<template>
  <v-container>
    <v-form lazy-validation v-model="valid" ref="form">
      <v-row class="mt-5">
        <v-col cols="12" sm="12" md="11" lg="11">
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Kasbon # <span class="red--text">*</span></v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                  <v-autocomplete
                    outlined
                    flat
                    dense
                    background-color="white"
                    v-model="kasbon"
                    item-text="kasbonNumber"
                    :items="listGeneralKasbon"
                    return-object
                    disabled
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ data.item.kasbonNumber }} ( {{ data.item.status }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Name</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6">
                  <span>{{ form.name }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Date</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                  <v-menu
                    v-model="menuDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        flat
                        dense
                        background-color="white"
                        v-model="form.date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.date"
                      :allowed-dates="getAllowedDates()"
                      @input="menuDate = false"
                      disabled
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Payment</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6">
                  <v-select
                    outlined
                    flat
                    dense
                    background-color="white"
                    v-model="form.paymentMethod"
                    :items="listPaymentMethod"
                    disabled
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" v-if="form.paymentMethod === 'Transfer'">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Account Number</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6">
                  <v-text-field
                    flat
                    dense
                    outlined
                    background-color="white"
                    v-model="form.bankAccountNumber"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Division</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                  <span>{{ form.division }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Currency</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6">
                  <span>{{ form.currency }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-row>
                <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                  <v-subheader>Remark</v-subheader>
                </v-col>
                <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                  <v-textarea
                    outlined
                    flat
                    rows="3"
                    background-color="white"
                    v-model="form.remark"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-tabs vertical>
                <v-tab background-color="light-blue accent-3" dark class="px-0">
                  <v-icon>
                    mdi-note-text
                  </v-icon>
                </v-tab>
                <v-tab-item>
                  <v-card flat class="px-2">
                    <v-row>
                      <v-col cols="6">
                        <v-autocomplete
                          outlined
                          flat
                          dense
                          background-color="white"
                          append-icon="mdi-magnify"
                          :items="listCategory"
                          item-text="category"
                          return-object
                          v-model="category"
                          @change="onChangeCategory"
                        >
                          <template v-slot:item="data">
                            <v-list-item v-on="data.on">
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.category"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" class="text-right pb-0">
                        <p class="headline font-italic">
                          Requirement <span class="red--text">*</span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="items"
                          disable-pagination
                          hide-default-footer
                          @click:row="onClickRow"
                        >
                          <template v-slot:item.no="{ index }">
                            {{ index + 1 }}
                          </template>
                          <template v-slot:item.amount="{ item }">
                            {{ formatPrice(item.amount) }}
                          </template>
                          <template v-slot:item.usedAmount="{ item }">
                            {{ formatPrice(item.usedAmount) }}
                          </template>
                          <template v-slot:item.remainAmount="{ item }">
                            {{ formatPrice(item.remainAmount) }}
                          </template>
                          <template v-slot:item.emoney="{ item }">
                            <v-checkbox v-model="item.emoney" dense disabled></v-checkbox>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="2">
              <v-card outlined>
                <v-card-title class="py-0">Total Kasbon</v-card-title>
                <v-card-text class="text-right mt-3">
                  <span>{{ formatPrice(totalAmount) }}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card outlined>
                <v-card-title class="py-0">Total Used</v-card-title>
                <v-card-text class="text-right mt-3">
                  <span>{{ formatPrice(totalUseAmount) }}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card outlined>
                <v-card-title class="py-0">Remain Kasbon</v-card-title>
                <v-card-text class="text-right mt-3">
                  <span>{{ formatPrice(totalRemainAmount) }}</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="1" lg="1" class="py-0">
          <v-row class="py-0">
            <v-col cols="12" class="mb-4 py-0">
              <v-btn
                v-if="$rbac.can('kasbon-external.create')"
                color="primary"
                @click="submit"
                :disabled="isOverLimit"
              >
                <v-icon large>
                  mdi-content-save
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="mb-4 py-0">
              <v-btn color="success" @click="reload">
                <v-icon large>
                  mdi-reload
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <dialog-kasbon
        :item="item"
        :index="index"
        :dialog="dialog"
        @close="close"
        @save="addItem"
        @deleteItem="deleteItem"
        type="settlement"
      ></dialog-kasbon>
      <v-dialog v-model="dialogAllowance" max-width="500" persistent>
        <v-card>
          <v-card-title
            :class="
              isOverLimit
                ? 'red white--text'
                : isWarning
                ? 'orange white--text'
                : 'blue white--text'
            "
          >
            <v-icon left color="white">{{
              isOverLimit ? "mdi-alert-circle" : isWarning ? "mdi-alert" : "mdi-information"
            }}</v-icon>
            {{ isOverLimit ? "Limit Habis" : isWarning ? "Peringatan" : "Informasi Allowance" }}
          </v-card-title>
          <v-card-text class="pt-4">
            <p>{{ allowanceMessage }}</p>
            <v-simple-table v-if="allowanceData" dense class="mt-2">
              <tbody>
                <tr>
                  <td>Allowance Bulanan</td>
                  <td class="text-right">Rp. {{ formatPrice(allowanceData.nominal) }}</td>
                </tr>
                <tr>
                  <td>Terpakai</td>
                  <td class="text-right">Rp. {{ formatPrice(allowanceData.actual) }}</td>
                </tr>
                <tr>
                  <td><strong>Sisa</strong></td>
                  <td
                    class="text-right"
                    :class="isOverLimit ? 'red--text' : isWarning ? 'orange--text' : 'green--text'"
                  >
                    <strong>Rp. {{ formatPrice(allowanceData.remain) }}</strong>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogAllowance = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogKasbon from "@/components/DialogKasbon";
import { fiscalMonthMixin } from "@/services/mixins/fiscalMonthMixin";

export default {
  name: "create-settlement-kasbon",
  mixins: [fiscalMonthMixin],
  components: {
    "dialog-kasbon": DialogKasbon,
  },
  props: {
    woId: Number,
  },
  data: () => ({
    defaultForm: {
      formNumber: "",
      date: moment().format("yyyy-MM-DD"),
      employeeId: 0,
      name: "",
      division: "",
      paymentMethod: "",
      remark: "",
      currency: null,
      accountNumberId: null,
      bankAccountNumber: "",
      totalAmount: 0,
      totalUseAmount: 0,
      totalRemainAmount: 0,
      generalKasbonId: null,
      items: [],
      status: "Outstanding",
      oldAssign: "",
      dppAmount: 0,
      taxDate: moment().format("yyyy-MM-DD"),
      taxSerialNumber: "",
    },
    menuDate: false,
    form: {},
    items: [],
    dialog: false,
    item: {},
    index: -1,
    category: null,
    listCategory: [],
    kasbon: null,
    listGeneralKasbon: [],
    listPaymentMethod: ["Cash", "Transfer"],
    valid: true,
    dialogAllowance: false,
    allowanceMessage: "",
    isOverLimit: false,
    isWarning: false,
    allowanceData: null,
    headers: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Requirement",
        value: "category",
        sortable: false,
        divider: true,
      },
      {
        text: "Description",
        value: "description",
        sortable: false,
        divider: true,
      },
      {
        text: "Start Date",
        value: "startDate",
        sortable: false,
        divider: true,
      },
      {
        text: "End Date",
        value: "endDate",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        divider: true,
      },
      {
        text: "Used Amount",
        value: "usedAmount",
        sortable: false,
        divider: true,
      },
      {
        text: "Remain Amount",
        value: "remainAmount",
        sortable: false,
        divider: true,
      },
      {
        text: "eMoney",
        value: "emoney",
        sortable: false,
        divider: true,
      },
      {
        text: "Account Name",
        value: "accountName",
        sortable: false,
        divider: true,
      },
    ],
  }),

  computed: {
    totalAmount() {
      let total = 0;
      this.items.map(x => {
        total = total + x.amount;
      });
      return total;
    },
    totalUseAmount() {
      let total = 0;
      this.items.map(x => {
        total = total + x.usedAmount;
      });
      return total;
    },
    totalRemainAmount() {
      let total = 0;
      this.items.map(x => {
        total = total + x.remainAmount;
      });
      return total;
    },

    ...mapState("settlementKasbon", ["lastFormNumber"]),
  },

  watch: {},

  methods: {
    async submit() {
      if (this.$refs.form.validate() && this.items.length > 0) {
        this.form.formNumber = this.lastFormNumber;
        this.form.totalAmount = this.totalAmount;
        this.form.totalUseAmount = this.totalUseAmount;
        this.form.totalRemainAmount = this.totalRemainAmount;
        this.form.items = this.items;

        this.$store.commit("SET_LOADER", true);
        await this.$store
          .dispatch("settlementKasbon/createExternal", this.form)
          .then(() => this.$store.commit("SET_LOADER", false))
          .catch(() => {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
            });
            this.$store.commit("SET_LOADER", false);
          });
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Requirement is required",
        });
      }
    },
    deleteItem(index) {
      if (index > -1) {
        this.items.splice(index, 1);
        this.dialog = false;
        this.category = null;
      }
    },
    addItem(item) {
      if (this.index > -1) {
        this.items[this.index] = item;
      } else {
        this.items.push({ ...item });
      }
      this.category = null;
    },
    close() {
      this.dialog = false;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    clear() {
      this.items = [];
      this.form = Object.assign({}, this.defaultForm);
    },
    async onChangeKasbon(val) {
      this.form.generalKasbonId = val.id;
      this.items = val.items;
      this.form.division = val.division;
      this.form.currency = val.currency;
      this.form.employeeId = val.employeeId;
      this.form.name = val.kasbonName;
      this.form.paymentMethod = val.paymentMethod;
      this.form.accountNumberId = val.accountNumberId;
      this.form.bankAccountNumber = val.bankAccountNumber;
      this.form.remark = val.remark;
      this.isOverLimit = false;
      this.isWarning = false;
      this.allowanceData = null;
      try {
        const res = await this.$store.dispatch("employeeAllowance/getLimit", val.employeeId);
        if (res && res.data) {
          this.allowanceData = res.data;
          if (res.data.overLimit) {
            this.isOverLimit = true;
            this.allowanceMessage =
              "Limit sudah habis, silahkan hubungi atasan untuk pengajuan limit baru.";
          } else if (res.data.warning) {
            this.isWarning = true;
            this.allowanceMessage = "Balance employee sudah melebihi batas aman.";
          } else {
            this.allowanceMessage = "Informasi sisa allowance employee.";
          }
          this.dialogAllowance = true;
        }
      } catch (e) {
        // Employee tanpa allowance record, skip
      }
    },
    onClickRow(item) {
      this.item = item;
      this.index = this.items.map(x => x).indexOf(item);
      this.dialog = true;
    },
    onChangeCategory(val) {
      this.item = val;
      this.index = this.items.findIndex(x => x === val);
      this.dialog = true;
    },
    onInputTotalUseAmount() {
      this.form.totalRemainAmount = this.totalAmount - this.form.totalUseAmount;
    },
    async getListCategory(id) {
      const response = await this.$store.dispatch("generalKasbon/getListCategoryByDepartment", id);
      if (response.status === 200) {
        this.listCategory = response.data;
      }
    },
    async getListGeneralKasbon() {
      const response = await this.$store.dispatch(
        "generalKasbon/getListGeneralKasbonForSettlement"
      );
      if (response.status === 200) {
        this.listGeneralKasbon = response.data;
      }
    },
    // eslint-disable-next-line no-unused-vars
    filterObject(item, queryText, itemText) {
      return (
        item.kasbonNumber.toString().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.status.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    async getKasbonByWoId() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("generalKasbon/getKasbonByWoId", this.woId)
        .then(response => {
          if (response.data) {
            this.kasbon = response.data;
            this.onChangeKasbon(this.kasbon);
            this.getListCategory(this.kasbon.departmentId);
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Kasbon not found, please check the kasbon is created or not",
            });
          }
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    reload() {
      window.location.reload();
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        await this.$store.dispatch("settlementKasbon/getLastFormNumber"),
        this.getListGeneralKasbon(),
        this.getKasbonByWoId(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },

  mounted() {
    this.getInitialData();
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
